export default "/images/d9f15c31bd900262c42b2928ac06f25e.avif";